import React from 'react';

const DropdownSelect = ({
  label,
  options,
  value,
  onChange,
  className,
  placeholder,
  disabled = false,
}) => {
  return (
    <div className={`sm:px-1 dark:border-dark-2 border-2 rounded-lg flex flex-col justify-start items-start ${className} overflow-hidden max-w-[8rem] xxs:max-w-[10rem]`}>
      <p className="px-0.5 xxxs:px-1 text-xs font-light text-darken">{label}</p>
      <div className="relative px-0.5">
        <select
          className={`xs:px-1 bg-transparent max-xs:text-xs${disabled ? " opacity-50" : ""}`}
          value={value}
          onChange={onChange}
          disabled={disabled}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((option, index) => (
            <option key={index} value={option.value} disabled={option.disabled}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DropdownSelect;
